// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__k6iZp","Content":"Layout_Content__365f3"};